import About from '@/pages/About'

export default {
    path: '/about',
    name: 'About',
    component: About
}


// WEBPACK FOOTER //
// ./src/router/about.js